import { API, Tag, TagsAPI } from "@brg/api";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { AGEYTOMESH_TAG_ID } from "shared/constants/misc";
import { AppTester } from "supporting";
import { useController, useFormContext } from "react-hook-form";
import TagsField from "shared/components/form/TagsField";

const RequiredTagSelect: FC<{ noLabel?: boolean }> = ({ noLabel }) => {
  const { field: { value: requiredTags = [], onChange } } = useController<{ [key: string]: Tag[] }>({ name: 'requiredTags' });
  const { getValues } = useFormContext();
  const {
    t,
    i18n: { language: lang },
  } = useTranslation();

  const isAgeytomesh = AppTester.isAgeytomesh();
  const isBrnd = AppTester.isBrnd();
  
  const tags = getValues('tags');

  const hasEducationalTagInNormalTags = useMemo(() => tags?.some((tag: any) => tag?.isEducationTag), [tags]);

  return (
    <>
    <TagsField
      name="requiredTags"
      label={t('project_edit.required_tags')}
      noLabel={noLabel}
      required={true}
      isProjectEdit
      modalOptions={{
        onChange: (tagsRaw: Tag[]) => {
          const tagIds = tagsRaw.map(tag => tag.tagId)
          if (tagIds.length) {
            TagsAPI.GetTags(({ tagIds, lang }))
              .then((v) => v.json())
              .then((v) => API.toLang<Tag[]>(v, lang))
              .then((tags) => onChange(tags));
          }
          onChange(tagsRaw);
        },
        max: 1,
        maxEducationalTags: hasEducationalTagInNormalTags ? 0 : 1,
        protectedTags: isAgeytomesh ? [AGEYTOMESH_TAG_ID] : [],
        isEdit: true,
        ignoreHeader: false,
        educational: true,
        hideGlobalSearchBar: isBrnd
      }}
    />
    </>
  );
    
};

export default RequiredTagSelect;import { API, Tag, TagsAPI } from "@brg/api";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { AGEYTOMESH_TAG_ID } from "shared/constants/misc";
import { AppTester } from "supporting";
import { useController, useFormContext } from "react-hook-form";
import TagsField from "shared/components/form/TagsField";

const RequiredTagSelect: FC<{ noLabel?: boolean }> = ({ noLabel }) => {
  const { field: { value: requiredTags = [], onChange } } = useController<{ [key: string]: Tag[] }>({ name: 'requiredTags' });
  const { getValues } = useFormContext();
  const {
    t,
    i18n: { language: lang },
  } = useTranslation();

  const isAgeytomesh = AppTester.isAgeytomesh();
  const isBrnd = AppTester.isBrnd();
  
  const tags = getValues('tags');

  const hasEducationalTagInNormalTags = useMemo(() => tags?.some((tag: any) => tag?.isEducationTag), [tags]);

  return (
    <>
    <TagsField
      name="requiredTags"
      label={t('project_edit.required_tags')}
      noLabel={noLabel}
      required={true}
      isProjectEdit
      modalOptions={{
        onChange: (tagsRaw: Tag[]) => {
          const tagIds = tagsRaw.map(tag => tag.tagId)
          if (tagIds.length) {
            TagsAPI.GetTags(({ tagIds, lang }))
              .then((v) => v.json())
              .then((v) => API.toLang<Tag[]>(v, lang))
              .then((tags) => onChange(tags));
          }
          onChange(tagsRaw);
        },
        max: 1,
        maxEducationalTags: hasEducationalTagInNormalTags ? 0 : 1,
        protectedTags: isAgeytomesh ? [AGEYTOMESH_TAG_ID] : [],
        isEdit: true,
        ignoreHeader: false,
        educational: true,
        hideGlobalSearchBar: isBrnd
      }}
    />
    </>
  );
    
};

export default RequiredTagSelect;